<template>
  <div>
    <div class="form-group">
      <label class="access-form__label">Qui a réalisé l'installation ?</label>
      <v-select :options="fitterOptions"
        :reduce="fitter => fitter.value"
        label="name"
        :searchable="false"
        :clearable="false"
        v-model="params.fitter_type">
      </v-select>
    </div>
    <div v-if="params.fitter_type === 'pro'">
      <div class="form-row">
        <r-input v-model="params.fitter_name" name="nom" label="Nom de l'installateur" icon="user-o" class="col-md-7" :error="error.fitter_name" />
        <r-input v-model="params.fitter_vat" label="Siret ou TVA de l'installateur" icon="building-o" class="col-md-5" :required="false" />
      </div>
      <r-input v-model="params.fitter_address" label="Adresse de l'installateur" icon="address-card-o" :required="false" />
      <div class="form-row">
        <zc-input v-model="params.fitter_zip_code" class="col-sm-4 mb-sm-0" :error="error.fitter_zip_code" />
        <r-input v-model="params.fitter_city" name="ville" label="Ville" icon="map-o" class="col-sm-8 mb-0" :error="error.fitter_city" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fitter',
  props: {
    params: Object,
    error: Object
  },
  data () {
    return {
      fitterOptions: [
        { name: 'Un professionel', value: 'pro' },
        { name: 'Moi-même', value: 'self' }
      ]
    }
  }
}
</script>
